"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _HorizontalRule = _interopRequireDefault(require("../../HorizontalRule"));

var _Text = _interopRequireDefault(require("../../Text"));

var _useRoundNumber = _interopRequireDefault(require("../../hooks/useRoundNumber"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Content = function Content(props) {
  var monthlyCP = props.monthlyCP,
      monthlySalary = props.monthlySalary,
      _props$totalCP = props.totalCP,
      totalCP = _props$totalCP === void 0 ? 0 : _props$totalCP,
      _props$totalSalary = props.totalSalary,
      totalSalary = _props$totalSalary === void 0 ? 0 : _props$totalSalary,
      _props$totalIFM = props.totalIFM,
      totalIFM = _props$totalIFM === void 0 ? 0 : _props$totalIFM,
      flexProps = (0, _objectWithoutProperties2["default"])(props, ["monthlyCP", "monthlySalary", "totalCP", "totalSalary", "totalIFM"]);
  var t = (0, _useTranslation["default"])();
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    flexDirection: "column"
  }, flexProps), (0, _core.jsx)(_Flex["default"], {
    flexDirection: "column",
    padding: 4
  }, (0, _core.jsx)(_Text["default"], {
    variant: "headline3"
  }, t('salary_explained')), (0, _core.jsx)(_Flex["default"], {
    flexDirection: "row",
    margin: [0, -2],
    padding: [4, 0, 0]
  }, (0, _core.jsx)(_Flex["default"], {
    flex: 0.3,
    margin: [0, 2],
    flexDirection: "column"
  }, (0, _core.jsx)(_Text["default"], {
    gutter: 2
  }, t('raw_salary')), (0, _core.jsx)(_Text["default"], {
    gutter: 2
  }, t('salary_with_CP')), (0, _core.jsx)(_Text["default"], null, t('salary_with_IFM'))), (0, _core.jsx)(_Flex["default"], {
    flex: 1,
    margin: [0, 2],
    flexDirection: "column"
  }, (0, _core.jsx)(_Text["default"], {
    gutter: 2,
    variant: "headline4"
  }, monthlySalary ? t('{count}_euros_by_month', {
    count: (0, _useRoundNumber["default"])(monthlySalary, 0)
  }) : t('{count}_euros_by_mission', {
    count: (0, _useRoundNumber["default"])(totalSalary, 0)
  })), (0, _core.jsx)(_Text["default"], {
    gutter: 2,
    variant: "headline4"
  }, monthlyCP ? t('{count}_euros_by_month', {
    count: (0, _useRoundNumber["default"])(monthlyCP, 0)
  }) : t('{count}_euros_by_mission', {
    count: (0, _useRoundNumber["default"])(totalCP, 0)
  })), (0, _core.jsx)(_Text["default"], {
    variant: "headline4"
  }, t('{count}_euros_by_mission', {
    count: (0, _useRoundNumber["default"])(totalIFM, 0)
  }))))), (0, _core.jsx)(_HorizontalRule["default"], {
    fullWidth: true
  }), (0, _core.jsx)(_Flex["default"], {
    flexDirection: "column",
    padding: 4
  }, (0, _core.jsx)(_Text["default"], {
    variant: "secondary",
    gutter: 2
  }, t('CP_description')), (0, _core.jsx)(_Text["default"], {
    variant: "secondary",
    gutter: 2
  }, t('IFM_description')), (0, _core.jsx)(_Text["default"], {
    variant: "secondary"
  }, t('amounts_are_raw'))));
};

__signature__(Content, "useTranslation{t}\nuseRoundNumber{}\nuseRoundNumber{}\nuseRoundNumber{}\nuseRoundNumber{}\nuseRoundNumber{}", function () {
  return [_useTranslation["default"], _useRoundNumber["default"], _useRoundNumber["default"], _useRoundNumber["default"], _useRoundNumber["default"], _useRoundNumber["default"]];
});

var _default = Content;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Content, "Content", "/builds/bA1zbJom/0/gojob/ui-bits/src/JobCard/SalaryDetails/Content.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/JobCard/SalaryDetails/Content.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();